/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { __decorate } from "tslib";
import { coreProperty, coerceNumber, coerceBoolean } from '@tylertech/forge-core';
import { BaseComponent } from '../core/base/base-component';
import { LIST_DROPDOWN_CONSTANTS } from './list-dropdown-constants';
export class ListDropdownAware extends BaseComponent {
    static get observedAttributes() {
        return Object.values(LIST_DROPDOWN_CONSTANTS.observedAttributes);
    }
    constructor() {
        super();
    }
    attributeChangedCallback(name, oldValue, newValue) {
        switch (name) {
            case LIST_DROPDOWN_CONSTANTS.observedAttributes.POPUP_CLASSES:
                this.popupClasses = newValue;
                break;
            case LIST_DROPDOWN_CONSTANTS.observedAttributes.OPTION_LIMIT:
                this.optionLimit = coerceNumber(newValue);
                break;
            case LIST_DROPDOWN_CONSTANTS.observedAttributes.OBSERVE_SCROLL:
                this.observeScroll = coerceBoolean(newValue);
                break;
            case LIST_DROPDOWN_CONSTANTS.observedAttributes.OBSERVE_SCROLL_THRESHOLD:
                this.observeScrollThreshold = coerceNumber(newValue);
                break;
            case LIST_DROPDOWN_CONSTANTS.observedAttributes.SYNC_POPUP_WIDTH:
                this.syncPopupWidth = coerceBoolean(newValue);
                break;
            case LIST_DROPDOWN_CONSTANTS.observedAttributes.CONSTRAIN_POPUP_WIDTH:
                this.constrainPopupWidth = coerceBoolean(newValue);
                break;
            case LIST_DROPDOWN_CONSTANTS.observedAttributes.WRAP_OPTION_TEXT:
                this.wrapOptionText = coerceBoolean(newValue);
                break;
            case LIST_DROPDOWN_CONSTANTS.observedAttributes.POPOVER_PLACEMENT:
                this.popoverPlacement = newValue;
                break;
            case LIST_DROPDOWN_CONSTANTS.observedAttributes.POPOVER_OFFSET:
                this.popoverOffset = JSON.parse(newValue);
                break;
            case LIST_DROPDOWN_CONSTANTS.observedAttributes.POPOVER_FLIP:
                this.popoverFlip = newValue;
                break;
            case LIST_DROPDOWN_CONSTANTS.observedAttributes.POPOVER_SHIFT:
                this.popoverShift = newValue;
                break;
        }
    }
}
__decorate([
    coreProperty()
], ListDropdownAware.prototype, "popupClasses", void 0);
__decorate([
    coreProperty()
], ListDropdownAware.prototype, "popupHeaderBuilder", void 0);
__decorate([
    coreProperty()
], ListDropdownAware.prototype, "popupFooterBuilder", void 0);
__decorate([
    coreProperty()
], ListDropdownAware.prototype, "syncPopupWidth", void 0);
__decorate([
    coreProperty()
], ListDropdownAware.prototype, "optionLimit", void 0);
__decorate([
    coreProperty()
], ListDropdownAware.prototype, "observeScroll", void 0);
__decorate([
    coreProperty()
], ListDropdownAware.prototype, "observeScrollThreshold", void 0);
__decorate([
    coreProperty()
], ListDropdownAware.prototype, "constrainPopupWidth", void 0);
__decorate([
    coreProperty()
], ListDropdownAware.prototype, "wrapOptionText", void 0);
__decorate([
    coreProperty()
], ListDropdownAware.prototype, "popoverPlacement", void 0);
__decorate([
    coreProperty()
], ListDropdownAware.prototype, "popoverOffset", void 0);
__decorate([
    coreProperty()
], ListDropdownAware.prototype, "popoverFlip", void 0);
__decorate([
    coreProperty()
], ListDropdownAware.prototype, "popoverShift", void 0);
__decorate([
    coreProperty()
], ListDropdownAware.prototype, "popoverFallbackPlacements", void 0);
